import { FormEvent, useState } from 'react';
import { Link } from 'react-router-dom';
import { api } from '../lib/api';
import AuthBrand from '../components/AuthBrand';
import InlineError from '../components/InlineError';

/**
 * Forgot password: requests Keycloak's UPDATE_PASSWORD email via the BFF.
 * The response is identical whether or not the address has an account
 * (anti-enumeration), so the UI always shows the "check your email" state.
 */
export default function ForgotPasswordPage() {
  const [email, setEmail] = useState('');
  const [sent, setSent] = useState(false);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<string>();

  async function onSubmit(e: FormEvent) {
    e.preventDefault();
    setBusy(true);
    setError(undefined);
    try {
      await api('/auth/forgot-password', { method: 'POST', body: JSON.stringify({ email }) });
      setSent(true);
    } catch (err) {
      setError((err as Error).message);
    } finally {
      setBusy(false);
    }
  }

  return (
    <main className="auth-page">
      <AuthBrand
        title="Reset your password"
        subtitle={sent ? 'Check your inbox' : "We'll email you a secure reset link."}
      />
      {sent ? (
        <div className="auth-card">
          <p>
            If an account exists for <strong>{email}</strong>, a password-reset email is on its way.
            The link is valid for 30 minutes.
          </p>
          <p style={{ marginTop: 14 }}><Link to="/sign-in">Back to sign in</Link></p>
        </div>
      ) : (
        <form className="auth-card" onSubmit={onSubmit}>
          <label>
            Email
            <input type="email" value={email} required autoComplete="username"
              onChange={(e) => setEmail(e.target.value)} />
          </label>
          {error && <InlineError message={error} />}
          <button type="submit" disabled={busy}>{busy ? 'Sending…' : 'Email me a reset link'}</button>
          <p style={{ marginTop: 12, textAlign: 'center' }}><Link to="/sign-in">Back to sign in</Link></p>
        </form>
      )}
    </main>
  );
}
